import { render, staticRenderFns } from "./authAdmin.vue?vue&type=template&id=2d86d56e&scoped=true"
import script from "./authAdmin.vue?vue&type=script&lang=js"
export * from "./authAdmin.vue?vue&type=script&lang=js"
import style0 from "./authAdmin.vue?vue&type=style&index=0&id=2d86d56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86d56e",
  null
  
)

export default component.exports